import type { ParticipateDropdownData } from '#/components/ParticipateDropdown/types/ParticipateDropdownData';
import type { I18nLocale } from '#/i18n/types/I18nLocale';

import { participateDropdownDataEs } from './participateDropdownData.es';
import { participateDropdownDataPt } from './participateDropdownData.pt';

export const participateDropdownDataByLocale: Record<
  I18nLocale.ES | I18nLocale.PT,
  ParticipateDropdownData
> = {
  es: participateDropdownDataEs,
  pt: participateDropdownDataPt,
};
